import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const ITEMS = [
  {
    name: "María Fernanda López",
    role: "Residencial · Providencia",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300&q=80&auto=format&fit=crop&crop=faces",
    text: "Excelente servicio de principio a fin. Las persianas blackout transformaron completamente nuestra recámara. La asesoría fue impecable.",
  },
  {
    name: "Carlos Ramírez",
    role: "Oficinas Corporativas · Andares",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&q=80&auto=format&fit=crop&crop=faces",
    text: "Instalaron Sheer Elegance en todo el corporativo. Acabados premium, puntualidad y un equipo muy profesional. Repetiremos sin duda.",
  },
  {
    name: "Andrea Vázquez",
    role: "Departamento · Chapalita",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&q=80&auto=format&fit=crop&crop=faces",
    text: "Me encantó el proceso: medición precisa, opciones bien explicadas y una instalación impecable. El panel japonés quedó espectacular.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="section bg-persia-light"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">

        <div className="max-w-2xl mb-10 md:mb-14">
          <div className="eyebrow mb-5">Clientes</div>

          <h2 className="font-display font-semibold text-persia-black text-3xl md:text-5xl leading-[1.1]">
            Lo que dicen{" "}
            <span className="italic font-light text-gold">
              nuestros clientes
            </span>
          </h2>

          <p className="mt-5 text-persia text-base md:text-lg font-light">
            Clientes residenciales y corporativos que confiaron en Persia para
            transformar sus espacios.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-7">
          {ITEMS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="luxury-card bg-white p-8 md:p-10 relative transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl"
            >
              <Quote
                className="text-gold/30 absolute top-6 right-6"
                size={42}
              />

              <div className="flex items-center gap-1 mb-6">
                {[...Array(5)].map((_, k) => (
                  <Star
                    key={k}
                    size={18}
                    className="fill-gold text-gold"
                  />
                ))}
              </div>

              <blockquote className="text-persia text-[15px] font-light leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </blockquote>

              <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-black/5">
                <img
                  src={t.avatar}
                  alt={t.name}
                  loading="lazy"
                  className="w-12 h-12 rounded-full object-cover"
                />

                <div>
                  <div className="font-display font-semibold text-persia-black text-sm">
                    {t.name}
                  </div>

                  <div className="text-persia text-xs font-light mt-0.5">
                    {t.role}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

      </div>
    </section>
  );
}